import { Fragment, useMemo } from 'react';
import { useRouter } from 'next/router';
import { formatDate } from '@wbk/utils';
import { EventListing, Team } from '@wbk/api';
import { DEFAULT_FLAG } from '@/src/constants/defaultFlag';
import ImageWithFallback from '../image/ImageWithFallback';

type Props = {
  match: EventListing & {
    home_team?: Pick<Team, '_id' | 'name' | 'logo'>;
    away_team?: Pick<Team, '_id' | 'name' | 'logo'>;
  };
};

const MatchCard = ({ match }: Props) => {
  const { locale } = useRouter();

  const matchDate = useMemo(() => {
    return {
      month: formatDate(match.start_date_time, locale, {
        month: 'short',
      }),
      day: formatDate(match.start_date_time, locale, {
        day: '2-digit',
      }),
    };
  }, [locale, match.start_date_time]);

  return (
    <>
      <div className='flex items-center justify-center gap-5 pb-2 text-secondary-600'>
        <figure className='relative h-20 w-20 shrink-0'>
          <ImageWithFallback
            src={match?.home_team?.logo}
            className='object-cover'
            fill
            sizes='200px'
            alt={match?.home_team?.name || ''}
            fallbackSrc={DEFAULT_FLAG}
          />
        </figure>
        <div className='rounded-md bg-gray-300 px-4 py-1.5 text-center leading-none'>
          {match.tbc ? (
            'TBC'
          ) : (
            <Fragment>
              <p>{matchDate.month}</p>
              <p className='text-xl font-bold'>{matchDate.day}</p>
            </Fragment>
          )}
        </div>
        <figure className='relative h-20 w-20 shrink-0'>
          <ImageWithFallback
            src={match?.away_team?.logo}
            className='object-cover'
            fill
            sizes='80px'
            alt={match?.away_team?.name || ''}
            fallbackSrc={DEFAULT_FLAG}
          />
        </figure>
      </div>
      <h3 className='text-center text-secondary-600'>{match.title}</h3>
    </>
  );
};

export default MatchCard;
